/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const errorEventPageItemsItemClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventPageItemsItemContextLocationOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventPageItemsItemContextProviderOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventPageItemsItemContextSlotStartOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const errorEventPageItemsItemContextVisitTypeOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventPageItemsItemGroupIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventPageItemsItemHttpStatusOneMin = -9007199254740991
export const errorEventPageItemsItemHttpStatusOneMax = 9007199254740991

export const errorEventPageItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventPageItemsItemOccurredAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const errorEventPagePageMax = 9007199254740991

export const errorEventPagePageSizeMax = 100

export const errorEventPageTotalMin = 0
export const errorEventPageTotalMax = 9007199254740991

export const ErrorEventPage = zod.object({
  items: zod.array(
    zod.object({
      clinic: zod
        .object({
          id: zod.uuid().regex(errorEventPageItemsItemClinicIdRegExp),
          name: zod.string(),
          slug: zod.string(),
        })
        .optional(),
      code: zod.string(),
      context: zod.object({
        location: zod.union([
          zod.object({
            id: zod.uuid().regex(errorEventPageItemsItemContextLocationOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
        provider: zod.union([
          zod.object({
            id: zod.uuid().regex(errorEventPageItemsItemContextProviderOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
        slotStart: zod.union([
          zod.iso.datetime({ offset: true }).regex(errorEventPageItemsItemContextSlotStartOneRegExp),
          zod.null(),
        ]),
        visitType: zod.union([
          zod.object({
            id: zod.uuid().regex(errorEventPageItemsItemContextVisitTypeOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
      }),
      groupId: zod.uuid().regex(errorEventPageItemsItemGroupIdRegExp),
      httpStatus: zod.union([
        zod.int().min(errorEventPageItemsItemHttpStatusOneMin).max(errorEventPageItemsItemHttpStatusOneMax),
        zod.null(),
      ]),
      id: zod.uuid().regex(errorEventPageItemsItemIdRegExp),
      message: zod.string(),
      occurredAt: zod.iso.datetime({ offset: true }).regex(errorEventPageItemsItemOccurredAtRegExp),
      requestId: zod.string(),
      source: zod.string().nullable(),
      step: zod.enum(['pf_lookup', 'availability', 'hold', 'pf_write', 'pf_message', 'pf_login']),
    }),
  ),
  page: zod.int().min(1).max(errorEventPagePageMax),
  pageSize: zod.int().min(1).max(errorEventPagePageSizeMax),
  total: zod.int().min(errorEventPageTotalMin).max(errorEventPageTotalMax),
})

export type ErrorEventPage = zod.input<typeof ErrorEventPage>
export type ErrorEventPageOutput = zod.output<typeof ErrorEventPage>
